import React from 'react'
import { Sparkles } from 'lucide-react'
import { Switch } from '@/components/ui/switch'

const NEW_LOOK_URL = 'https://healthycoach.io'

// Always shown "on"; any click takes the user to the new site in the same window, with no params.
// Navigate via a rel="noreferrer" link so no Referer is sent; otherwise the new site appends it as ?oref=...
const NewLookToggle = () => {
  const openNewLook = () => {
    const link = document.createElement('a')
    link.href = NEW_LOOK_URL
    link.rel = 'noreferrer'
    link.referrerPolicy = 'no-referrer'
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  return (
    <label
      htmlFor="new-look-toggle"
      className="group flex flex-shrink-0 cursor-pointer select-none items-center gap-2 rounded-full border border-primary/20 bg-primary/5 py-1 pl-2.5 pr-1 transition-colors hover:border-primary/40 hover:bg-primary/10"
      title="Switch to the new look"
    >
      <Sparkles className="h-3.5 w-3.5 text-primary" aria-hidden="true" />
      <span className="text-[13px] font-medium text-slate-900">New Look</span>
      <Switch
        id="new-look-toggle"
        checked
        onCheckedChange={openNewLook}
        aria-label="New Look"
        className="h-5 w-9 shadow-inner data-[state=checked]:bg-primary"
        thumbClassName="h-4 w-4 data-[state=checked]:translate-x-4"
      />
    </label>
  )
}

export default NewLookToggle
